@for (course of courses(); track $index; let isFirst = $first; let isLast = $last) {
	<uc-course-card
		[isFirst]="isFirst"
		[isLast]="isLast"
		[course]="course"
		[uniSlug]="uniSlug()"
		[product]="clearing"
		productAbbr="cle"
		[uniId]="uniId()"
		[uniName]="uniName()"
		[ugSearchOrderPosition]="null"
		[cleSearchOrderPosition]="cleSearchOrderPosition()"
		[degreeLevel]="degreeLevel()"
		[region]="region()"
		[isHECoSSubject]="isHECoSSubject()"
		[searchTerm]="searchTerm()"
	>
		<uc-course-card-clearing-btns
			ctaButtons
			[isFeatured]="isFeatured"
			[isFeaturedCalls]="isFeaturedCalls"
			[isFeaturedRegisterInterest]="isFeaturedRegisterInterest"
			[phoneNumber]="phoneNumber()"
			[externalUrl]="externalUrl()"
			sourceType="course"
			[uniId]="uniId()"
			[uniName]="uniName()"
			[courseId]="course.id"
			[courseName]="course.name"
			[courseSlug]="course.slug"
			[isCourseSaved]="course.saved"
			[cleSearchOrderPosition]="cleSearchOrderPosition()"
			[academicYear]="course.year"
			[privacyPolicyUrl]="privacyPolicyUrl()"
		/>
	</uc-course-card>
}
